import { Typography } from '@sweep-io/sweep-design';
import Box from '@mui/material/Box';
import { ReactNode } from 'react';

interface TitleWithSubtitleProps {
  label: string;
  subtitle?: ReactNode;
}

export const TitleWithSubtitle = ({ label, subtitle }: TitleWithSubtitleProps) => {
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Box display="flex" gap={1} alignItems="center">
        <Typography variant="h4-medium" whiteSpace="break-spaces" wordBreak="break-word">
          {label}
        </Typography>
      </Box>

      {subtitle}
    </Box>
  );
};
